import useScript from 'utils/useScript'

const GA_SCRIPT_URL = 'https://www.googletagmanager.com/gtag/js?id=UA-52108117-4'
const GoogleAnalyticsTracker = () => {
  useScript(GA_SCRIPT_URL, () => {
    window.dataLayer = window.dataLayer || []
    function gtag(...args: Array<string | Date>) {
      window.dataLayer?.push(args)
    }
    gtag('js', new Date())
    gtag('config', 'UA-52108117-4')
  })
  return null
}

export default GoogleAnalyticsTracker
